import React, { Component } from 'react';
import _ from 'lodash';
import { SLOW, FAST } from '../../HOME/const';

class Shape extends Component {
  render() {
    const { p1, p2, p3, easein, color } = this.props;
    const xmin = _.min([Number(p1.x), Number(p2.x), Number(p3.x)]);
    const ymin = _.min([Number(p1.y), Number(p2.y), Number(p3.y)]);
    const xmax = _.max([Number(p1.x), Number(p2.x), Number(p3.x)]);
    const ymax = _.max([Number(p1.y), Number(p2.y), Number(p3.y)]);
    const data = `M${p1.x} ${p1.y} L${p2.x} ${p2.y} L${p3.x} ${p3.y} Z`;
    const width = xmax - xmin;
    const height = ymax - ymin;
    const viewbox = `${xmin} ${ymin} ${width} ${height}`;
    const margin = `${ymin}px 0 0 ${xmin}px`;
    const cls = `${easein ? 'fadein-animation' : ''}`;
    const duration = `${easein === SLOW || easein === FAST ? easein : 0}ms`;

    return (
      <div className={cls} style={{ gridArea: '1/1', margin: margin, animationDuration: duration }}>
        <svg
          width={width}
          height={height}
          viewBox={viewbox}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path d={data} fill={color} />
        </svg>
      </div>
    );
  }
}

export default Shape;
